import { List, Set, Map } from "immutable";
import Build from "@material-ui/icons/Build";
import Class from "@material-ui/icons/Class";

export const DEFAULT_MOMENT_LOCALE = "en-gb";

export const IN_DEV = process.env.NODE_ENV === "development" ? true : false;

export const Environments = {
  LOCAL: "Local",
  DEV: "ALTUSDEV",
  TST: "ALTUSTST",
  PRD: "ALTUSPRD",
  SBX: "ALTUSSBX",
  SCA: "ALTUSSCA",
};

export const APP_ACTIONS = {
  ASYNC_END: "ASYNC_END",
  ASYNC_START: "ASYNC_START",
  GET_CURRENT_USER: "GET_CURRENT_USER",
  APPLICATION_ON_LOAD: "APPLICATION_ON_LOAD",
  TOGGLE_PANEL: "TOGGLE_PANEL",
  REPLACE_PANEL: "REPLACE_PANEL",
  REMOVE_NOTIFICATION: "REMOVE_NOTIFICATION",
  GET_ALL_APP_ROLES: "GET_ALL_APP_ROLES",
  CREATE_USER_APP_ROLES: "CREATE_USER_APP_ROLE",
  DELETE_USER_APP_ROLE: "DELETE_USER_APP_ROLE",
  SELECT_USER_APP_ROLES: "SELECT_USER_APP_ROLES",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  SET_APPLICATION_FAILURE: "SET_APPLICATION_FAILURE",
  WINDOW_LOCATION_RELOAD: "WINDOW_LOCATION_RELOAD",

  /**
   * User
   */
  GET_USERS: "GET_USERS",
  UPDATE_USER: "UPDATE_USER",
};

export const Format = {
  date: "YYYY-MM-DD",
  time: "YYYY-MM-DD HH:mm",
  workSchedule: "dddd, D MMM YYYY",
  pobReport: "dddd, D MMM YYYY, HH:mm",
  dashboard: "dddd, D MMM YYYY, HH:mm:ss",
};

export const EMPTY_LIST = List();
export const EMPTY_SET = Set();
export const EMPTY_MAP = Map();

export const WORK_SCHEDULE_REPORT_MAX_MONTHS = 6;

// TODO
// This is a temporary quick fix to allow users to select from a predefined set of colors
// In the future it should be possible to add/delete from this list
export const DummyCardCQualifications = List([
  Map({ backColor: "#98ffb3", name: "Info1" }),
  Map({ backColor: "#ffa6ff", name: "Info2" }),
  Map({ backColor: "#f1f80c", name: "Overtime" }),
  Map({ backColor: "#008000", name: "Flexdays" }),
]);

export const APP_ROLES = {
  VIEWER: "HRPlannerViewer",
  PLANNER: "HRPlannerPlanner",
  ADMIN: "HRPlannerAdmin",
};

export const APP_NAME = "Personnel Planner";

export const ICONS = {
  COURSE: Class,
  SKILL: Build,
};
